import { AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { Chart } from 'chart.js/auto';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { MatAccordion } from '@angular/material/expansion';
import { KeyWord } from 'src/app/shared/classes/constants';
import { ActivatedRoute } from '@angular/router';
import { EditorService } from 'src/app/shared/services/editor.service';
import Annotation from 'chartjs-plugin-annotation';
import * as XLSX from 'xlsx';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Socket } from 'ngx-socket-io';

@Component({
  selector: 'app-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReportDetailComponent implements OnInit, AfterViewInit {
  uid: any = "";
  window: any = window;
  theme: boolean = true;
  panelOpenState: boolean = false;
  indexNumber = new Array(10);
  activeKeyWord = 'All';
  activeKeyWordPaa = "Quora";
  titleHeaderName: any[] = KeyWord.titleHeaderName;
  structureHeaderName: any[] = KeyWord.StructureHeaderName;
  keywordHeaderName: any[] = KeyWord.keywordHeaderName;
  // topCompititorTitle = KeyWord.topCompititorTitle;
  expensionTitle: any;
  chart?: Chart;
  auditReportData: any = {};
  allData: any[] = [];
  titleData: any[] = [];
  headingData: any[] = [];
  top3Data: any[] = [];
  h1Data: any[] = [];
  h2Data: any[] = [];
  nlpData: any[] = [];
  paaData: any[] = [];
  mainContentData: any[] = [];
  topCompetitorTitle: any[] = [];
  charts: any = [];
  score: number = 0;
  isAvailable: boolean = false;
  isH1Available: boolean = false;
  isTitleAvailable: boolean = false;
  nlp_score: number = 0;
  loading: boolean = false;
  aid: string = "";
  titleIdleCount = { min: 0, max: 1 };
  Object = Object;
  @ViewChild('id') canvas?: ElementRef;
  @ViewChildren('canvases') canvases?: QueryList<ElementRef>;
  @ViewChild(MatAccordion) accordion?: MatAccordion;
  mainContentSwitch: string = "idle";
  titleContentData: any[] = [];
  is_done: boolean = false;
  refreshFlag: boolean = false;
  isoptimised: boolean = false;
  isPartial: boolean = false;
  isNotUsed: boolean = false;
  structureObj: any = [
    { key: "Body", latestCount: 0, min: 0, max: 0 },
    { key: "Paragraph", latestCount: 0, min: null, max: null },
    { key: "H1", latestCount: 0, min: null, max: null },
    { key: "H2", latestCount: 0, min: null, max: null },
    { key: "H3", latestCount: 0, min: null, max: null },
    { key: "H4-H6", latestCount: 0, min: null, max: null },
    { key: "Bold/B", latestCount: 0, min: null, max: null }
  ];
  exactKeyword: any = [
    { key: "Number of exact keywords in Title", yourCount: 0, min: 0, max: 1 },
    { key: "Number of exact keywords in H1", yourCount: 0, min: 0, max: 1 },
    { key: "Number of exact keywords in Body", yourCount: 0, min: 0, max: 1 },
    { key: "Number of exact keywords in Paragraph", yourCount: 0, min: 0, max: 0 },
    { key: "Number of exact keywords in H2", yourCount: 0, min: 0, max: 0 },
    { key: "Number of exact keywords in H3", yourCount: 0, min: 0, max: 0 },
    { key: "Number of exact keywords in H4-H6", yourCount: 0, min: 0, max: 1 },
    { key: "Number of exact keywords in Strong,B", yourCount: 0, min: 0, max: 0 }
  ];
  noOfElements: any = [
    { key: "No. of H1 elements", yourCount: 0, min: 0, max: 1 },
    { key: "No. of Paragraph elements", yourCount: 0, min: 0, max: 0 },
    { key: "No. of H2 elements", yourCount: 0, min: 0, max: 0 },
    { key: "No. of H3 elements", yourCount: 0, min: 0, max: 0 },
    { key: "No. of H4-H6 elements", yourCount: 0, min: 0, max: 1 },
    { key: "No. of Strong,B elements", yourCount: 0, min: 0, max: 0 },
    { key: "No. of Image elements", yourCount: 0, min: 0, max: 0 }
  ];
  quickFix: any = [
    { key: "Main keyword in Title", yourCount: 0 },
    { key: "Main keyword in H1", yourCount: 0 },
    { key: "H1 tag used", yourCount: 0 },
    { key: "Title tag used", yourCount: 0 },
  ]
  metaDesc = { key: "Number of characters in Meta description", yourCount: 0, min: 50, max: 160 };
  get menu() {
    return !this.theme ? 'providers-menu' : ''
  }
  get popover() {
    return !this.theme ? 'dark-popover ' : ''
  }
  constructor(
    private themingService: ThemingService,
    private modal: NgbModal,
    private activatedRouter: ActivatedRoute,
    private editorService: EditorService,
    public _snackBar: MatSnackBar,
    private cookieServ: CookieService,
    private toster: ToastrService,
    private socket: Socket,
  ) {
    this.uid = this.cookieServ.get("uid");
    // this.uid = "u-8842b392-d3ae-11ed-bbac-7738ed7ada70";
    // this.themingService.nameKeeper.subscribe(val => this.theme = val);
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    });
    this.activatedRouter.params.subscribe(params => {
      this.aid = params['id'] //log the value of id
      // this.getAudit(params['id']);
      this.themingService.setId(this.aid);

    });
    // this.getAllData();
    this.socket.on('softAuditCompleted', (data: any) => {
      if (!!data && !!data.data) {
        this.getAuditData(this.aid)
        this.refreshFlag = false
        this.toster.success('Refresh has been completed.')
      }
    })

  }
  activeLink = 'Structure';

  ngOnInit(): void {
    this.getAuditData();
    this.themingService.pingThemeName();
    Chart.register(Annotation);
    this.titleHeaderName = this.titleHeaderName.map(e => {
      return { title: e, ispanelOpenState: true }
    });
    this.structureHeaderName = this.structureHeaderName.map(e => {
      return { title: e, ispanelOpenState: true }
    });
    this.keywordHeaderName = this.keywordHeaderName.map(e => {
      return { title: e, ispanelOpenState: true }
    });
  }

  ngOnDestroy(): void {
    this.socket.removeListener("softAuditCompleted");
    this.modal.dismissAll();
  }
  ngAfterViewInit() {
    this.initGraphs();
    // this.accordion?.openAll();
  }
  initGraphs() {
    this.destroyCharts()
    let bodyYRange = { "data": [this.auditReportData?.audit?.base?.word_len?.body], min: this.auditReportData?.structure[0]?.min, max: this.auditReportData?.structure[0]?.max };
    let paragraphYrange = { "data": [this.auditReportData?.audit?.base?.word_len?.p], min: this.auditReportData.structure[1].min, max: this.auditReportData.structure[1].max };
    let h1YRange = { "data": [this.auditReportData?.audit?.base?.word_len?.h1], min: this.auditReportData.structure[2].min, max: this.auditReportData.structure[2].max };
    let h2YRange = { "data": [this.auditReportData?.audit?.base?.word_len?.h2], min: this.auditReportData.structure[3].min, max: this.auditReportData.structure[3].max };
    let h3YRange = { "data": [this.auditReportData?.audit?.base?.word_len?.h3], min: this.auditReportData.structure[4].min, max: this.auditReportData.structure[4].max };
    let h46YRange = { "data": [this.auditReportData?.audit?.base?.word_len?.h46], min: this.auditReportData.structure[5].min, max: this.auditReportData.structure[5].max };
    let boldYRange = { "data": [this.auditReportData?.audit?.base?.word_len?.b], min: this.auditReportData.structure[6].min, max: this.auditReportData.structure[6].max };
    let titleEleYrange = { "data": [this.exactKeyword[2].yourCount], min: this.exactKeyword[2].min, max: this.exactKeyword[2].max };
    let h1EleYrange = { "data": [this.exactKeyword[2].yourCount], min: this.exactKeyword[2].min, max: this.exactKeyword[2].max };
    let bodyEleYrange = { "data": [this.exactKeyword[2].yourCount], min: this.exactKeyword[2].min, max: this.exactKeyword[2].max };
    let paragraphYElerange = { "data": [this.exactKeyword[3].yourCount], min: this.exactKeyword[3].min, max: this.exactKeyword[3].max };
    let h2YElerange = { "data": [this.exactKeyword[4].yourCount], min: this.exactKeyword[4].min, max: this.exactKeyword[4].max };
    let h3YElerange = { "data": [this.exactKeyword[4].yourCount], min: this.exactKeyword[4].min, max: this.exactKeyword[4].max };
    let h46YElerange = { "data": [this.exactKeyword[4].yourCount], min: this.exactKeyword[4].min, max: this.exactKeyword[4].max };
    let bYElerange = { "data": [this.exactKeyword[4].yourCount], min: this.exactKeyword[4].min, max: this.exactKeyword[4].max };

    let h1Elemrange = { "data": [this.noOfElements[0].yourCount], min: this.noOfElements[0].min, max: this.noOfElements[0].max };
    let paragraphElemrange = { "data": [this.noOfElements[1].yourCount], min: this.noOfElements[1].min, max: this.noOfElements[1].max };
    let h2Elemrange = { "data": [this.noOfElements[2].yourCount], min: this.noOfElements[2].min, max: this.noOfElements[2].max };
    let h3Elemrange = { "data": [this.noOfElements[3].yourCount], min: this.noOfElements[3].min, max: this.noOfElements[3].max };
    let h46Elemrange = { "data": [this.noOfElements[4].yourCount], min: this.noOfElements[4].min, max: this.noOfElements[4].max };
    let bElemrange = { "data": [this.noOfElements[5].yourCount], min: this.noOfElements[5].min, max: this.noOfElements[5].max };
    let imgelemrange = { "data": [this.noOfElements[6].yourCount], min: this.noOfElements[6].min, max: this.noOfElements[6].max };

    let metaDescription = { "data": [this.metaDesc.yourCount], min: this.metaDesc.min, max: this.metaDesc.max };

    // let top5Compititors = this.topCompetitorTitle.slice(0, 5);
    this.topCompetitorTitle.forEach((e, index) => {
      bodyYRange.data[index + 1] = e.word_len.body;
      paragraphYrange.data[index + 1] = e.word_len.p;
      h1YRange.data[index + 1] = e.word_len.h1;
      h2YRange.data[index + 1] = e.word_len.h2;
      h3YRange.data[index + 1] = e.word_len.h3;
      h46YRange.data[index + 1] = e.word_len.h46;
      boldYRange.data[index + 1] = e.word_len.b;
      titleEleYrange.data[index + 1] = e.eleLength.title;
      h1EleYrange.data[index + 1] = e.eleLength.h1;
      bodyEleYrange.data[index + 1] = e.eleLength.body;
      paragraphYElerange.data[index + 1] = e.eleLength.p;
      h2YElerange.data[index + 1] = e.eleLength.h2;
      h3YElerange.data[index + 1] = e.eleLength.h3;
      h46YElerange.data[index + 1] = e.eleLength.h46;
      bYElerange.data[index + 1] = e.eleLength.b;
      h1Elemrange.data[index + 1] = e?.h1?.count;
      paragraphElemrange.data[index + 1] = e?.p?.count;
      h2Elemrange.data[index + 1] = e?.h2?.count;
      h3Elemrange.data[index + 1] = e?.h3?.count;
      h46Elemrange.data[index + 1] = e?.h46?.count;
      bElemrange.data[index + 1] = e?.b?.count;
      imgelemrange.data[index + 1] = e?.img?.count;
      metaDescription.data[index + 1] = e?.meta_description[0]?.replace(/\s/g, "").length;
    });
    setTimeout(() => {
      this.canvases?.forEach((canvas, index) => {
        let graphArg = {};
        switch (index) {
          case 0:
            graphArg = bodyYRange
            break;
          case 1:
            graphArg = paragraphYrange
            break;
          case 2:
            graphArg = h1YRange
            break;
          case 3:
            graphArg = h2YRange
            break;
          case 4:
            graphArg = h3YRange
            break;
          case 5:
            graphArg = h46YRange
            break;
          case 6:
            graphArg = boldYRange
            break;
          case 7:
            graphArg = titleEleYrange
            break;
          case 8:
            graphArg = h1EleYrange
            break;
          case 9:
            graphArg = bodyEleYrange
            break;
          case 10:
            graphArg = paragraphYElerange
            break;
          case 11:
            graphArg = h2YElerange
            break;
          case 12:
            graphArg = h3YElerange
            break;
          case 13:
            graphArg = h46YElerange
            break;
          case 14:
            graphArg = bYElerange
            break;
          case 15:
            graphArg = h1Elemrange
            break;
          case 16:
            graphArg = paragraphElemrange
            break;
          case 17:
            graphArg = h2Elemrange
            break;
          case 18:
            graphArg = h3Elemrange
            break;
          case 19:
            graphArg = h46Elemrange
            break;
          case 20:
            graphArg = bElemrange
            break;
          case 21:
            graphArg = imgelemrange
            break;
          case 22:
            graphArg = metaDescription
            break;
          default:
            graphArg = [1000, 2000, 3000, 4000, 5000, 6000];
            break;
        }
        this.InitGraph(canvas, graphArg)
      }
      );
    }, 1000);
  }

  destroyCharts() {
    this.charts?.forEach((e: any) => {
      e.destroy()
    })
    this.charts = [];
  }
  scoreCount() {
    // this.score = 0;
    let score = 0;
    let h1Elements = this.auditReportData?.audit?.base?.h1?.text;
    let h2Elements = this.auditReportData?.audit?.base?.h2?.text;
    let h3Elements: any = [];
    let pElements = this.auditReportData?.audit?.base?.p?.text;
    let title = this.auditReportData?.audit?.base?.title?.text;

    let checkH1 = h1Elements?.some((el: any) => {
      return el?.toLocaleLowerCase().includes(this.auditReportData.audit.keyword.toLocaleLowerCase())
    });
    let checkH2 = h2Elements?.some((el: any) => {
      return el?.toLocaleLowerCase().includes(this.auditReportData.audit.keyword.toLocaleLowerCase())
    });
    for (let key in this.auditReportData?.audit?.base?.h3?.kw) {
      this.auditReportData?.audit?.base?.h3?.kw[key]?.forEach((el: any) => {
        h3Elements.push(el);
      })
    }
    let checkH3 = h3Elements?.some((el: any) => {
      return el?.toLocaleLowerCase()?.includes(this.auditReportData.audit.keyword.toLocaleLowerCase())
    });
    let pArr: any = [];
    for (let key in pElements) {
      pElements[key]?.forEach((el: any) => {
        pArr.push(el);
      })
    }
    let checkP = pArr?.some((el: any) => {
      return el?.toLocaleLowerCase()?.includes(this.auditReportData.audit.keyword.toLocaleLowerCase())
    });
    if (!!checkH1) {
      score += 8;
    }
    if (!!checkH2) {
      score += 2;
    }
    if (!!checkP) {
      score += 2;
    }
    if (!!checkH3) {
      score += 1;
    }
    if (title[0]?.toLocaleLowerCase().includes(this.auditReportData.audit.keyword.toLocaleLowerCase())) {
      score += 7;
    }
    if (this.auditReportData.audit.base?.word_len.p >= this.auditReportData.structure[1]?.min && this.auditReportData.audit.base?.word_len.p <= this.auditReportData.structure[1]?.max) {
      score += 12;
    }
    let h2Score = this.h2Data.filter(e => { return e.yourCount > 0 });
    if (h2Score.length > 0) {
      score += (h2Score.length * 15) / this.h2Data.length
    }
    let h2mainContentScore = this.mainContentData.filter(e => { return e.yourCount > 0 });
    if (h2mainContentScore.length > 0) {
      let temp = h2mainContentScore.length / this.mainContentData.length * 100;
      score += temp > 50 ? 50 : temp

    }
    if (this.noOfElements[5].yourCount > 0) {
      score += 1
    }
    if (this.noOfElements[1].yourCount > 0) {
      score += 2
    }
    // if (score > 20 && score < 20) {
    //   let remainingScore = 100 - score;
    //   let additionalScore = remainingScore / 4
    //   this.score = score + additionalScore;
    // } else {
    this.score = score;
    // }
    this.saveAuditScore();
  }
  getAllData(id?: string) {
    this.loading = true;
    this.activatedRouter.data.subscribe(res => {
      if (!!res && res.editor) {
        this.nlp_score = (res.editor.audit.keywords.reduce((a: any, b: any) => ({ occurance: a?.occurance + b?.occurance })).occurance / res.editor?.audit?.keywords?.length);
        if (!!res.editor.audit.is_done) {
          this.is_done = true;
        }
        // this.editorService.getAuditReport(res.id).subscribe(res => {
        this.auditReportData = res.editor;
        this.auditReportData['structure'] = this.structureObj;
        this.paaData = res?.editor?.audit?.paa;

        this.titleData = res.editor?.audit?.keywords_title?.map((e: any) => {
          let mx = res.editor?.audit?.base?.title?.kw[e.keyword] ? res.editor?.audit?.base?.title?.kw[e.keyword]?.length : 0;

          e['suggestedCount'] = { min: Math.floor(e.min * mx), max: Math.floor(e.max * mx) }

          e.isTitle = true; e.yourCount = 0;
          return e
        });
        res.editor.audit.keywords = res.editor.audit.keywords.map((e: any) => {
          return { ...e, nlp: e.occurance > this.nlp_score ? true : false }
        });
        this.metaDesc.yourCount = res.editor.audit.base?.meta_description[0] ? res.editor.audit.base?.meta_description[0]?.replace(/\s/g, "").length : 0;
        for (let keyy in res?.editor?.audit?.data) {
          let elementLength = {
            title: 0,
            h1: 0,
            body: 0,
            p: 0,
            h2: 0,
            h3: 0,
            h46: 0,
            b: 0,
          }
          elementLength.body = res?.editor?.audit?.data[keyy]?.body[this.auditReportData.audit.keyword];
          for (let key in res?.editor?.audit?.data[keyy]?.p?.text) {
            res?.editor?.audit?.data[keyy].p?.text[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.p += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.title?.kw) {
            res?.editor?.audit?.data[keyy]?.title?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.title += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.h1?.kw) {
            res?.editor?.audit?.data[keyy]?.h1?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h1 += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.h2?.kw) {
            res?.editor?.audit?.data[keyy]?.h2?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h2 += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.h3?.kw) {
            res?.editor?.audit?.data[keyy]?.h3?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h3 += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.h46?.kw) {
            res?.editor?.audit?.data[keyy]?.h46?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h46 += 1;
              }
            })
          }
          for (let key in res?.editor?.audit?.data[keyy]?.b?.text) {
            res?.editor?.audit?.data[keyy]?.b.text[key]?.forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.b += 1;
              }
            })
          }
          res.editor.audit.data[keyy]['eleLength'] = elementLength;
        }
        this.titleData.forEach(e => {
          // let count = 0;
          // for (let key in res.editor.audit.base?.title.kw) {
          //   debugger
          if (!!res.editor.audit.base?.title?.kw[e.keyword]) {
            e['yourCount'] = res.editor.audit.base?.title?.kw[e.keyword]?.length;
          }
          // res.editor?.audit?.base?.title?.kw[key].forEach((el: any) => {
          //   if (el.includes(this.auditReportData.audit.keyword)) {
          //     count = count + 1
          //     e['yourCount'] = count;
          //   }
          // })
          // }
        })


        this.h1Data = res.editor?.audit?.keywords_h1?.map((e: any) => { e.isH1 = true; e.yourCount = 0; e.isH = true; return e });
        this.h1Data.forEach(e => {
          if (!!res.editor.audit.base?.h1?.kw[e.keyword]) {
            e['yourCount'] = res.editor.audit.base?.h1?.kw[e.keyword]?.length;
          }
          // let count = 0;
          // for (let key in res.editor?.audit?.base?.h1?.kw) {
          //   res.editor?.audit?.base?.h1?.kw[key].forEach((el: any) => {
          //     if (el.toLowerCase().includes(e?.keyword.toLowerCase())) {
          //       count = count + 1
          //       e['yourCount'] = count;
          //     }
          //   })
          // }

        })

        this.h2Data = res.editor?.audit?.keywords_h2?.map((e: any) => { e.isH1 = true; e.yourCount = 0; e.isH = true; return e });
        this.h2Data.forEach(e => {
          if (!!res.editor.audit.base?.h2?.kw[e.keyword]) {
            e['yourCount'] = res.editor.audit.base?.h2?.kw[e.keyword]?.length;
          }
          // let count = 0;
          // for (let key in res.editor.audit.base?.h2.kw) {
          //   res.editor.audit.base?.h2.kw[key].forEach((el: any) => {
          //     if (el.toLowerCase().includes(e.keyword.toLowerCase())) {
          //       count = count + 1
          //       e['yourCount'] = count;
          //     }
          //   })
          // }

        })
        let bodyx: any = [];
        let multix = 1;
        Object.values(this.auditReportData.audit.data).forEach((d: any) => { bodyx.push(parseInt(d.word_len.body)) });
        let bodyAvg = Math.floor(bodyx.reduce((a: any, b: any) => a + b, 0) / bodyx.length);
        multix = this.auditReportData.audit.base?.word_len?.body / bodyAvg;
        this.mainContentData = res.editor?.audit?.keywords;
        this.mainContentData.forEach(el => {
          el['yourCount'] = 0;
          el['suggestedCount'] = { min: Math.floor(el.min * multix), max: Math.floor(el.max * multix) }
          el['isH'] = (res.editor.audit.keywords_h1.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase()) || res.editor.audit.keywords_h2.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase())) ? true : false,
            el['isTitle'] = res.editor.audit.keywords_title.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase());
        });
        this.titleContentData = this.mainContentData.filter(el => {
          return el.isTitle === true;
        });
        this.mainContentData.forEach(e => {
          // if(!!res.editor.audit.base?.p.text[e.keyword]){
          //   e['yourCount'] = res.editor.audit.base?.p.text[e.keyword]?.length;
          // }
          let count = 0;
          for (let key in res.editor.audit?.base?.p?.text) {
            if (key === e.keyword.toLowerCase()) {
              e['yourCount'] = res.editor.audit?.base?.p?.text[key]?.length;
            }
            // res.editor.audit.base?.p?.text[key]?.forEach((el: any) => {
            //   if (el.toLowerCase().includes(e.keyword.toLowerCase())) {
            //     count = count + 1
            //     e['yourCount'] = count;
            //   }
            // })
          }

        });
        this.nlpData = this.mainContentData.filter(el => {
          return el.nlp === true;
        });
        this.headingData = this.mainContentData.filter(e => {
          return e.isH === true;
        });
        this.top3Data = this.mainContentData.filter(e => { return e.top3 == true }).map(el => { el.isTop3 = true; return el });
        // this.mainContentData = [...this.mainContentData, ...this.top3Data];
        this.score = res.editor.audit.content_score;
        let checkKeyinH1 = res.editor?.audit?.base?.h1?.text?.some((e: any) => { e.toLowerCase()?.includes(res.editor?.audit?.keyword?.toLowerCase()) });
        let checkKeyinTitle = res.editor?.audit?.base?.title?.text?.some((e: any) => { e.toLowerCase()?.includes(res.editor?.audit?.keyword?.toLowerCase()) });
        if (!!checkKeyinH1 || !!checkKeyinTitle) {
          this.isAvailable = true;
        }
        if (!!checkKeyinH1) {
          this.isH1Available = true;
        }
        if (!!checkKeyinTitle) {
          this.isTitleAvailable = true;
        }
        this.quickFix[2].yourCount = this.auditReportData.audit.base?.h1?.count;
        this.quickFix[3].yourCount = this.auditReportData.audit.base?.title?.count;
        this.noOfElements[0].yourCount = this.auditReportData?.audit?.base?.h1?.count;
        this.noOfElements[1].yourCount = this.auditReportData?.audit?.base?.p?.count;
        this.noOfElements[2].yourCount = this.auditReportData?.audit?.base?.h2?.count;
        this.noOfElements[3].yourCount = this.auditReportData?.audit?.base?.h3?.count;
        this.noOfElements[4].yourCount = this.auditReportData?.audit?.base?.h4?.count + this.auditReportData?.audit?.base?.h5?.count + this.auditReportData?.audit?.base?.h6?.count;
        this.noOfElements[5].yourCount = this.auditReportData?.audit?.base?.b?.count;
        this.noOfElements[6].yourCount = this.auditReportData?.audit?.base?.img?.count;

        // this.auditReportData.audit.base?.h1?.text?.forEach((e: any) => {
        if (this.auditReportData.audit.base?.h1?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.quickFix[1].yourCount += 1;
        }
        // });
        // this.auditReportData.audit.base?.title?.text?.forEach((e: any) => {
        if (this.auditReportData.audit.base?.title?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.quickFix[0].yourCount += 1;
        }
        // })
        this.getMinmax();
        this.getDensity();
        // })
      }
      this.loading = false;
    })
  }
  getMinmax() {
    let data: any = []
    this.Object.values(this.auditReportData.audit.data).forEach((e: any) => {
      if (!!this.auditReportData.audit.competitors.includes(e.position.toString())) {
        this.topCompetitorTitle.push(e);
        data.push(e);
      }
    });
    if (!!this.auditReportData && !!this.auditReportData.structure && this.auditReportData.structure.length > 0) {
      data.forEach((element: any) => {
        // let h2h6Count = 0;
        // h2h6Count = element.h2.count + element.h3.count + element.h4.count + element.h5.count + element.h6.count;
        // if (!this.auditReportData.structureElements[1].min || this.auditReportData.structureElements[1].min > h2h6Count) {
        //   this.auditReportData.structureElements[1].min = h2h6Count
        // }
        // if (!this.auditReportData.structureElements[1].max || this.auditReportData.structureElements[4].max < h2h6Count) {
        //   this.auditReportData.structureElements[1].max = h2h6Count
        // }
        for (let key in element) {
          if (key === "word_len") {
            // if (!this.auditReportData?.structure[0]?.min || this.auditReportData?.structure[0]?.min > element.word_len.body) {
            //   this.auditReportData.structure[0].min = element.word_len.body;
            // }

            // if (!this.auditReportData?.structure[0]?.max || this.auditReportData?.structure[0]?.max < element.word_len.body) {
            //   this.auditReportData.structure[0].max = element.word_len.body;
            // }
            var min = Math.min(...data.map((item: any) => item.word_len.body));
            var max = Math.max(...data.map((item: any) => item.word_len.body));
            this.auditReportData.structure[0].min = min;
            this.auditReportData.structure[0].max = max;
            // if (!this.auditReportData.structure[1].min || this.auditReportData.structure[1].min > element.word_len.p) {
            //   this.auditReportData.structure[1].min = element.word_len.p;
            // }

            // if (!this.auditReportData.structure[1].max || this.auditReportData.structure[1].max < element.word_len.p) {
            //   this.auditReportData.structure[1].max = element.word_len.p;
            // }
            var min = Math.min(...data.map((item: any) => item.word_len.p));
            var max = Math.max(...data.map((item: any) => item.word_len.p));
            this.auditReportData.structure[1].min = min;
            this.auditReportData.structure[1].max = max;
            // if (!this.auditReportData.structure[2].min || this.auditReportData.structure[2].min > element.word_len.h1) {
            //   this.auditReportData.structure[2].min = element.word_len.h1;
            // }
            var min = Math.min(...data.map((item: any) => item.word_len.h1));
            var max = Math.max(...data.map((item: any) => item.word_len.h1));
            this.auditReportData.structure[2].min = min;
            this.auditReportData.structure[2].max = max;
            var min = Math.min(...data.map((item: any) => item.word_len.h2));
            var max = Math.max(...data.map((item: any) => item.word_len.h2));
            this.auditReportData.structure[3].min = min;
            this.auditReportData.structure[3].max = max;
            var min = Math.min(...data.map((item: any) => item.word_len.h3));
            var max = Math.max(...data.map((item: any) => item.word_len.h3));
            this.auditReportData.structure[4].min = min;
            this.auditReportData.structure[4].max = max;
            var min = Math.min(...data.map((item: any) => item.word_len.h46));
            var max = Math.max(...data.map((item: any) => item.word_len.h46));
            this.auditReportData.structure[5].min = min;
            this.auditReportData.structure[5].max = max;
            var min = Math.min(...data.map((item: any) => item.word_len.b));
            var max = Math.max(...data.map((item: any) => item.word_len.b));
            this.auditReportData.structure[6].min = min;
            this.auditReportData.structure[6].max = max;
            // if (!this.auditReportData.structure[2].max || this.auditReportData.structure[2].max < element.word_len.h1) {
            //   this.auditReportData.structure[2].max = element.word_len.h1;
            // }
            // if (!this.auditReportData.structure[3].min || this.auditReportData.structure[3].min > element.word_len.h2) {
            //   this.auditReportData.structure[3].min = element.word_len.h2;
            // }

            // if (!this.auditReportData.structure[3].max || this.auditReportData.structure[3].max < element.word_len.h2) {
            //   this.auditReportData.structure[3].max = element.word_len.h2;
            // }
            // if (!this.auditReportData.structure[4].min || this.auditReportData.structure[4].min > element.word_len.h3) {
            //   this.auditReportData.structure[4].min = element.word_len.h3;
            // }

            // if (!this.auditReportData.structure[4].max || this.auditReportData.structure[4].max < element.word_len.h3) {
            //   this.auditReportData.structure[4].max = element.word_len.h3;
            // }
            // if (!this.auditReportData.structure[5].min || this.auditReportData.structure[5].min > element.word_len.h46) {
            //   this.auditReportData.structure[5].min = element.word_len.h46;
            // }

            // if (!this.auditReportData.structure[5].max || this.auditReportData.structure[5].max < element.word_len.h46) {
            //   this.auditReportData.structure[5].max = element.word_len.h46;
            // }
            // if (!this.auditReportData.structure[6].min || this.auditReportData.structure[6].min > element.word_len.b) {
            //   this.auditReportData.structure[6].min = element.word_len.b;
            // }

            // if (!this.auditReportData.structure[6].max || this.auditReportData.structure[6].max < element.word_len.b) {
            //   this.auditReportData.structure[6].max = element.word_len.b;
            // }
            // if (!this.auditReportData.structureCharacters[0].min || this.auditReportData.structureCharacters[0].min > element.word_len.title) {
            //   this.auditReportData.structureCharacters[0].min = element.word_len.title
            // }
            // if (!this.auditReportData.structureCharacters[0].max || this.auditReportData.structureCharacters[0].max < element.word_len.title) {
            //   this.auditReportData.structureCharacters[0].max = element.word_len.title
            // }
          }
          if (key === 'p') {
            if (!this.noOfElements[1].min || this.noOfElements[1].min > element[key].count) {
              this.noOfElements[1].min = element[key].count
            }
            if (!this.noOfElements[1].max || this.noOfElements[1].max < element[key].count) {
              this.noOfElements[1].max = element[key].count
            }
          }
          if (key === 'h2') {
            if (!this.noOfElements[2].min || this.noOfElements[2].min > element[key].count) {
              this.noOfElements[2].min = element[key].count
            }
            if (!this.noOfElements[2].max || this.noOfElements[2].max < element[key].count) {
              this.noOfElements[2].max = element[key].count
            }
          }
          if (key === 'h3') {
            if (!this.noOfElements[3].min || this.noOfElements[3].min > element[key].count) {
              this.noOfElements[3].min = element[key].count
            }
            if (!this.noOfElements[3].max || this.noOfElements[3].max < element[key].count) {
              this.noOfElements[3].max = element[key].count
            }
          }
          if (key === 'h46') {
            element[key].count = element.h4.count + element.h5.count + element.h6.count
            if (!this.noOfElements[4].min || this.noOfElements[4].min > element[key].count) {
              this.noOfElements[4].min = element[key].count
            }
            if (!this.noOfElements[4].max || this.noOfElements[4].max < element[key].count) {
              this.noOfElements[4].max = element[key].count
            }
          }
          if (key === "b") {
            if (!this.noOfElements[5].min || this.noOfElements[5].min > element[key].count) {
              this.noOfElements[5].min = element[key].count
            }
            if (!this.noOfElements[5].max || this.noOfElements[5].max < element[key].count) {
              this.noOfElements[5].max = element[key].count
            }
          }
          if (key === "img") {
            if (!this.noOfElements[6].min || this.noOfElements[6].min > element[key].count) {
              this.noOfElements[6].min = element[key].count
            }
            if (!this.noOfElements[6].max || this.noOfElements[6].max < element[key].count) {
              this.noOfElements[6].max = element[key].count
            }
          }
          // if (key === "b") {
          //   if (!this.auditReportData.structureElements[3].min || this.auditReportData.structureElements[3].min > element[key].count) {
          //     this.auditReportData.structureElements[3].min = element[key].count
          //   }
          //   if (!this.auditReportData.structureElements[3].max || this.auditReportData.structureElements[3].max < element[key].count) {
          //     this.auditReportData.structureElements[3].max = element[key].count
          //   }
          // }
          // if (key === "p") {
          //   if (!this.auditReportData.structureElements[2].min || this.auditReportData.structureElements[2].min > element[key].count) {
          //     this.auditReportData.structureElements[2].min = element[key].count
          //   }
          //   if (!this.auditReportData.structureElements[2].max || this.auditReportData.structureElements[2].max < element[key].count) {
          //     this.auditReportData.structureElements[2].max = element[key].count
          //   }
          // }
          // if (key === "h1") {
          //   if (!this.auditReportData.structureElements[0].min || this.auditReportData.structureElements[0].min > element[key].count) {
          //     this.auditReportData.structureElements[0].min = element[key].count
          //   }
          //   if (!this.auditReportData.structureElements[0].max || this.auditReportData.structureElements[0].max < element[key].count) {
          //     this.auditReportData.structureElements[0].max = element[key].count
          //   }
          // }
          // if (key === "h2" || key === "h3" || key === "h4" || key === "h5" || key === "h6") {
          //   h2h6Count = h2h6Count + element[key].count;
          //   this.Object.keys(element[key].kw).forEach(e => {
          //     pCount = pCount + e.split(" ").filter(element => element).length;
          //   });
          //   if (!this.auditReportData.structure[3].min || this.auditReportData.structure[3].min > pCount) {
          //     this.auditReportData.structure[3].min = pCount;
          //   }

          //   if (!this.auditReportData.structure[3].max || this.auditReportData.structure[3].max < pCount) {
          //     this.auditReportData.structure[3].max = pCount;
          //   }
          // }

          // if (key === "img") {
          //   if (!this.auditReportData.structureElements[4].min || this.auditReportData.structureElements[4].min > element[key].count) {
          //     this.auditReportData.structureElements[4].min = element[key].count
          //   }
          //   if (!this.auditReportData.structureElements[4].max || this.auditReportData.structureElements[4].max < element[key].count) {
          //     this.auditReportData.structureElements[4].max = element[key].count
          //   }
          // }
        }
      });

    }
    this.scoreCount();
  }
  getDensity() {

    for (let key in this.auditReportData.audit.data) {
      if (!this.exactKeyword[2].min || this.exactKeyword[2].min > this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword]) {
        this.exactKeyword[2].min = this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword] : 0;
      }
      if (!this.exactKeyword[2].max || this.exactKeyword[2].max < this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword]) {
        this.exactKeyword[2].max = this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.body[this.auditReportData.audit.keyword] : 0;
      }
      for (let key1 in this.auditReportData.audit.data[key].p.text) {
        let count = 0;
        this.auditReportData.audit.data[key].p.text[key1].forEach((el: any) => {
          if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
            count += 1;
          }
        })
        if (!this.exactKeyword[3].min || this.exactKeyword[3].min > count) {
          this.exactKeyword[3].min = count;
        }
        if (!this.exactKeyword[3].max || this.exactKeyword[3].max < count) {
          this.exactKeyword[3].max = count;
        }
      }
      let h2Count = 0;
      for (let key2 in this.auditReportData.audit.data[key].h2.kw) {
        this.auditReportData.audit.data[key].h2.kw[key2].forEach((el: any) => {
          if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
            h2Count += 1;
          }
        })
        if (!this.exactKeyword[4].min || this.exactKeyword[4].min > h2Count) {
          this.exactKeyword[4].min = h2Count;
        }
        if (!this.exactKeyword[4].max || this.exactKeyword[4].max < h2Count) {
          this.exactKeyword[4].max = h2Count
        }
      }
      let h3Count = 0;
      for (let key3 in this.auditReportData.audit.data[key].h3.kw) {
        this.auditReportData.audit.data[key].h3.kw[key3].forEach((el: any) => {
          if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
            h3Count += 1;
          }
        })
        if (!this.exactKeyword[5].min || this.exactKeyword[5].min > h3Count) {
          this.exactKeyword[5].min = h3Count;
        }
        if (!this.exactKeyword[5].max || this.exactKeyword[5].max < h3Count) {
          this.exactKeyword[5].max = h3Count;
        }
      }
      if (!this.exactKeyword[6].min || this.exactKeyword[6].min > this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword]?.length) {
        this.exactKeyword[6].min = this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword]?.length : 0;
      }
      if (!this.exactKeyword[6].max || this.exactKeyword[6].max < this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword]?.length) {
        this.exactKeyword[6].max = this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.h46[this.auditReportData.audit.keyword]?.length : 0;
      }
      // let h46Count = 0;
      // if(Object.entries(this.auditReportData.audit.data[key].h46).length > 0){
      //   for (let key3 in this.auditReportData.audit.data[key].h46) {
      //     this.auditReportData.audit.data[key]?.h46[key3]?.forEach((el: any) => {
      //       if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
      //         h46Count += 1;
      //       }
      //     })
      //     if (!this.exactKeyword[6].min || this.exactKeyword[6].min > h46Count) {
      //       this.exactKeyword[6].min = h46Count;
      //     }
      //     if (!this.exactKeyword[6].max || this.exactKeyword[6].max < h46Count) {
      //       this.exactKeyword[6].max = h46Count;
      //     }
      //   }
      // }

      let bCount = 0;

      for (let key4 in this.auditReportData.audit.data[key].b.text) {
        this.auditReportData.audit.data[key].b.text[key4]?.forEach((el: any) => {
          if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
            bCount += 1;
          }
        })
        if (!this.exactKeyword[7].min || this.exactKeyword[7].min > bCount) {
          this.exactKeyword[7].min = bCount;
        }
        if (!this.exactKeyword[7].max || this.exactKeyword[7].max < bCount) {
          this.exactKeyword[7].max = bCount;
        }
      }
      // if (!this.exactKeyword[7].min || this.exactKeyword[7].min > this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword]?.length) {
      //   this.exactKeyword[7].min = this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword]?.length : 0;
      // }
      // if (!this.exactKeyword[7].max || this.exactKeyword[7].max < this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword]?.length) {
      //   this.exactKeyword[7].max = this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword] ? this.auditReportData.audit?.data[key]?.b?.text[this.auditReportData.audit.keyword]?.length : 0;
      // }
    }
    // if(!!this.auditReportData.audit.base?.title.kw[this.auditReportData.audit.keyword.toLowerCase()]){
    //   this.exactKeyword[0].yourCount = this.auditReportData.audit.base?.title.kw[this.auditReportData.audit.keyword.toLowerCase()].length;
    // }
    // if(!!this.auditReportData.aud    it.base?.h1.kw[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[1].yourCount = this.auditReportData.audit.base?.h1.kw[this.auditReportData.audit.keyword.toLowerCase()].length
    // }
    if (!!this.auditReportData.audit.base?.body[this.auditReportData.audit.keyword.toLowerCase()]) {
      this.exactKeyword[2].yourCount = this.auditReportData.audit.base?.body[this.auditReportData.audit.keyword.toLowerCase()];
    }
    // if(!!this.auditReportData.audit.base?.p.text[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[3].yourCount = this.auditReportData.audit.base?.p.text[this.auditReportData.audit.keyword.toLowerCase()].length
    // }
    // if(!!this.auditReportData.audit.base?.h2.kw[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[4].yourCount = this.auditReportData.audit.base?.h2.kw[this.auditReportData.audit.keyword.toLowerCase()].length
    // 
    // if(!!this.auditReportData.audit.base?.h3.kw[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[5].yourCount = this.auditReportData.audit.base?.h3.kw[this.auditReportData.audit.keyword.toLowerCase()].length
    // }
    // if(!!this.auditReportData.audit.base?.h46.kw[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[6].yourCount = this.auditReportData.audit.base?.h46.kw[this.auditReportData.audit.keyword.toLowerCase()].length
    // }
    // if(!!this.auditReportData.audit.base?.b.text[this.auditReportData.audit.keyword.toLowerCase()]) {
    //   this.exactKeyword[7].yourCount = this.auditReportData.audit.base?.b.text[this.auditReportData.audit.keyword.toLowerCase()].length
    // }
    // for (let key in this.auditReportData.audit.base?.p?.text) {
    //   this.auditReportData.audit.base?.p?.text[key]?.forEach((el: any) => {
    //     if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
    //       this.exactKeyword[3].yourCount += 1;
    //     }
    //   })
    // }
    this.auditReportData.audit.base?.p?.kw?.forEach((element: any) => {
      var found = element.toLowerCase().split(this.auditReportData.audit.keyword.toLowerCase()).length - 1;
      this.exactKeyword[3].yourCount += found;
    });
    // for (let key in this.auditReportData.audit.base?.title?.kw) {
    //   this.auditReportData.audit.base?.title?.kw[key]?.forEach((el: any) => {
    if (this.auditReportData.audit.base?.title?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
      this.exactKeyword[0].yourCount += 1;
      //   }
      // })
    }
    // for (let key in this.auditReportData.audit.base?.h1?.kw) {
    //   this.auditReportData.audit.base?.h1?.kw[key]?.forEach((el: any) => {
    if (this.auditReportData.audit.base?.h1?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
      this.exactKeyword[1].yourCount += 1;
    }
    //   })
    // }
    this.auditReportData.audit.base?.h2?.text.forEach((element: any) => {
      var found = element.toLowerCase().split(this.auditReportData.audit.keyword.toLowerCase()).length - 1;
      this.exactKeyword[4].yourCount += found;
    });
    this.auditReportData.audit.base?.h3?.text?.forEach((element: any) => {
      var found = element.toLowerCase().split(this.auditReportData.audit.keyword.toLowerCase()).length - 1;
      this.exactKeyword[5].yourCount += found;
    });
    // for (let key in this.auditReportData.audit.base?.h3?.kw) {
    //   this.auditReportData.audit.base?.h3?.kw[key]?.forEach((el: any) => {
    //     if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
    //       this.exactKeyword[5].yourCount += 1;
    //     }
    //   })
    // }
    for (let key in this.auditReportData.audit.base?.h46?.kw) {
      this.auditReportData.audit.base?.h46?.kw[key]?.forEach((el: any) => {
        if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.exactKeyword[6].yourCount += 1;
        }
      })
    }
    for (let key in this.auditReportData.audit.base?.b?.text) {
      this.auditReportData.audit.base?.b?.text[key]?.forEach((el: any) => {
        if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.exactKeyword[7].yourCount += 1;
        }
      })
    }
  }

  InitGraph(index?: any, arg?: any) {
    const context = index?.nativeElement?.getContext('2d');
    let a = arg?.max + Math.pow(10, (arg?.max?.toString().length - 1));
    let b: any = [a];
    let labels = ['Base'];
    let bgColor = [arg?.data[0] >= arg?.min && arg?.data[0] <= arg?.max ? '#30B28C' : arg?.data[0] < arg?.min ? '#ED8936' : '#C25B5B'];
    let borderColor = [arg?.data[0] >= arg?.min && arg?.data[0] <= arg?.max ? '#30B28C' : arg?.data[0] < arg?.min ? '#ED8936' : '#C25B5B'];
    let d2bgColor = ['#F3F4F7']
    this.topCompetitorTitle.forEach((el, index) => {
      b.push(a);
      labels.push(`#${index + 1}`);
      bgColor.push('#B9BABD');
      borderColor.push('#B9BABD');
      borderColor.push('#F3F4F7')

    });
    const footer = (tooltipItems: any) => {
      // let sum = 0;

      // tooltipItems.forEach(function(tooltipItem:any) {
      //   sum += tooltipItem.parsed.y;
      // });
      if (tooltipItems.dataIndex !== 0) {
        return new URL(this.topCompetitorTitle[tooltipItems.dataIndex - 1].url).hostname;
      } else {
        return new URL(this.auditReportData?.audit?.url)?.hostname;
      }
    };
    if (!!arg && arg.data && arg.data.length > 0) {
      const annotation2: any = {
        type: 'box',
        backgroundColor: '#30b28c33',
        borderColor: '#30b28c33',
        borderWidth: 1,
        drawTime: 'beforeDatasetsDraw',
        xMax: -1,
        xMin: this.topCompetitorTitle.length,
        xScaleID: 'x',
        yMax: arg?.max,
        yMin: arg?.min,
        yScaleID: 'y'
      };

      // this.chart?.clear();
      let chart = new Chart(context, {
        type: "bar",
        data: {
          labels: labels,
          datasets: [{
            label: "data1",
            data: arg?.data,
            backgroundColor: bgColor,
            borderColor: borderColor,
            borderWidth: 1,
            borderRadius: 7,
            borderSkipped: false,
          },
          {
            label: "data2",
            data: b,
            backgroundColor: d2bgColor,
            borderColor: d2bgColor,
            borderWidth: 1,
            borderRadius: 7,
            borderSkipped: false
          }
          ]
        },
        options: {
          scales: {
            x: {
              stacked: true,
              grid: {
                color: "rgba(0, 0, 0, 0)",
              },
              border: {
                color: "rgba(0, 0, 0, 0)",
              },
            },
            y: {
              stacked: false,
              grid: {
                color: "rgba(0, 0, 0, 0)",
              },
              border: {
                color: "rgba(0, 0, 0, 0)",
              },

            }
          },
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: true,
              filter: function (tooltipItem) {
                return tooltipItem.dataset.label === "data1" ? true : false;
              },
              callbacks: {
                label: footer,
              }

            },
            annotation: {
              annotations: {
                annotation2
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false,
        }
      });

      this.charts.push(chart);
    }
  }

  openModal(title: any, modalExample?: any) {
    const modalRef = this.modal.open(ModalComponent, { centered: true, windowClass: !this.theme ? 'dark-modal custom-modal' : 'custom-modal' });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.theme = this.theme;
    modalRef.componentInstance.examples = modalExample;
    modalRef.componentInstance.competitorList = this.auditReportData.audit.data;
    modalRef.componentInstance.defaultCompetitor = this.auditReportData.audit.competitors_default;
    modalRef.componentInstance.competitors = this.auditReportData.audit.competitors;
    modalRef.result.then(e => {
      if (title === "CompetitorSettingAudit") {
        this.editorService.saveAuditCompititor({ cid: this.auditReportData.audit.aid, competitors: e.arr }).subscribe(res => {
          this.getAuditData(this.aid)
          // window.location.reload();
          // this.getAuditData();
        })
      }
    })
  }


  exportAllDataAsExcel() {

    let quick_fix_ary: any = []
    let all_data_ary: any = []
    let title_data: any = []
    let h1_data: any = []
    let h2_data: any = []
    let main_content_data: any = []
    let top_30_data: any = []

    quick_fix_ary = [
      ["Main keyword in Title", "N/A", "Action require"],
      ["Main keyword in H1", "2", "Action require"],
      ["H1 tag used", "2", "Action require"],
      ["Title tag used", "2", "Action require"]
    ]

    all_data_ary = [
      { keyword: "Number of words in Body", a: this.auditReportData?.audit?.base?.word_len?.body, b: this.auditReportData?.structure[0]?.min + "-" + this.auditReportData?.structure[0]?.max },
      { keyword: "Number of words in Paragraph", a: this.auditReportData?.audit?.base?.word_len?.p, b: this.auditReportData?.structure[1]?.min + "-" + this.auditReportData?.structure[1]?.max },
      { keyword: "Number of words in H1", a: this.auditReportData?.audit?.base?.word_len?.h1, b: this.auditReportData?.structure[2]?.min + "-" + this.auditReportData?.structure[2]?.max },
      { keyword: "Number of words in H2", a: this.auditReportData?.audit?.base?.word_len?.h2, b: this.auditReportData?.structure[3]?.min + "-" + this.auditReportData?.structure[3]?.max },
      { keyword: "Number of words in H3", a: this.auditReportData?.audit?.base?.word_len?.h3, b: this.auditReportData?.structure[4]?.min + "-" + this.auditReportData?.structure[4]?.max },
      { keyword: "Number of words in H4-H6", a: this.auditReportData?.audit?.base?.word_len?.h46, b: this.auditReportData?.structure[5]?.min + "-" + this.auditReportData?.structure[5]?.max },
      { keyword: "Number of words in Strong,B", a: this.auditReportData?.audit?.base?.word_len?.b, b: this.auditReportData?.structure[6]?.min + "-" + this.auditReportData?.structure[6]?.max },
    ]

    title_data = this.titleData.map((v: any) => {
      return { keyword: v.keyword, yourCount: v.yourCount, Ideal_count: v.min + "-" + v.max, Relevancy: "100%" }
    })
    h1_data = this.h1Data.map((v: any) => {
      return { keyword: v.keyword, yourCount: v.yourCount, Ideal_count: v.min + "-" + v.max, Relevancy: "100%" }
    })
    h2_data = this.h2Data.map((v: any) => {
      return { keyword: v.keyword, yourCount: v.yourCount, Ideal_count: v.min + "-" + v.max, Relevancy: "100%" }
    })
    main_content_data = this.mainContentData.map((v: any) => {
      return { keyword: v.keyword, yourCount: v?.yourCount, Ideal_count: v.min + "-" + v.max, Suggested_count: v?.suggestedCount?.min + "-" + v?.suggestedCount?.max, Relevancy: "100%" }
    })
    const quick_fix = XLSX.utils.aoa_to_sheet(quick_fix_ary);
    const all_data = XLSX.utils.json_to_sheet(all_data_ary);
    const title = XLSX.utils.json_to_sheet(title_data);
    const h1 = XLSX.utils.json_to_sheet(h1_data);
    const h2 = XLSX.utils.json_to_sheet(h2_data);
    const main_content = XLSX.utils.json_to_sheet(main_content_data);

    var Heading = [
      ["Element", "Your Count", "Ideal Count"]
    ];
    var titleHeading = [
      ["Keyword", "Your Count", "Ideal Count", "Relevancy"]
    ];
    var mainHeading = [
      ["Keyword", "Your Count", "Ideal Count", "Suggested count", "Relevancy"]
    ];

    let quickFix = [
      { wch: 30, DBF: { name: "Element" } },
      { wch: 10, DBF: { name: "Your Count" } },
      { wch: 20, DBF: { name: "Ideal Count" } },
    ]
    let wscols1 = [
      { wch: 30, DBF: { name: "Element" } },
      { wch: 10, DBF: { name: "Your Count" } },
      { wch: 10, DBF: { name: "Ideal Count" } },
    ]
    let titleWs1 = [
      { wch: 30, DBF: { name: "Keyword" } },
      { wch: 10, DBF: { name: "Your Count" } },
      { wch: 10, DBF: { name: "Ideal Count" } },
      { wch: 10, DBF: { name: "Relevancy" } },
    ]
    let mainTitle = [
      { wch: 30, DBF: { name: "Keyword" } },
      { wch: 10, DBF: { name: "Your Count" } },
      { wch: 10, DBF: { name: "Ideal Count" } },
      { wch: 10, DBF: { name: "Suggested count" } },
      { wch: 10, DBF: { name: "Relevancy" } },
    ]

    quick_fix['!cols'] = quickFix;
    all_data['!cols'] = wscols1;
    title['!cols'] = titleWs1;
    h1['!cols'] = titleWs1;
    h2['!cols'] = titleWs1;
    main_content['!cols'] = mainTitle;

    XLSX.utils.sheet_add_aoa(all_data, Heading);
    XLSX.utils.sheet_add_aoa(title, titleHeading);
    XLSX.utils.sheet_add_aoa(h1, titleHeading);
    XLSX.utils.sheet_add_aoa(h2, titleHeading);
    XLSX.utils.sheet_add_aoa(main_content, mainHeading);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, quick_fix, `Quick Fix`);
    XLSX.utils.book_append_sheet(wb, all_data, `Words`);
    XLSX.utils.book_append_sheet(wb, title, `Title Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, h1, `H1 Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, h2, `H2 Tag Keyword`);
    XLSX.utils.book_append_sheet(wb, main_content, `Main Content Keyword`);

    XLSX.writeFile(wb, `strell_${this.auditReportData?.audit?.keyword != undefined ? this.auditReportData?.audit?.keyword : "Audit"}_${new Date().toISOString().split('T')[0]}.xlsx`);

  }
  completeAudit() {
    this.editorService.completeAudit({ req_type: "completed" }, this.auditReportData?.audit?.aid).subscribe(res => {
      if (!!res) {
        // this.toster.info(res.message);
        if (res.message === "Retry has been started.Audit has been marked complete.") {
          this.is_done = true;
        } else {
          this.is_done = false;
        }
        // window.location.reload();
        // this.getAuditData();

      }
    })
  }
  getAuditData(id?: string) {
    this.loading = true;
    this.editorService.getAuditReport(this.aid).subscribe(res => {
      if (!!res) {
        this.nlp_score = res?.audit?.keywords?.length != 0 ? (res.audit.keywords.reduce((a: any, b: any) => ({ occurance: a?.occurance + b?.occurance })).occurance / res?.audit?.keywords?.length) : 0;
        // this.editorService.getAuditReport(res.id).subscribe(res => {
        this.structureObj = [
          { key: "Body", latestCount: 0, min: 0, max: 0 },
          { key: "Paragraph", latestCount: 0, min: null, max: null },
          { key: "H1", latestCount: 0, min: null, max: null },
          { key: "H2", latestCount: 0, min: null, max: null },
          { key: "H3", latestCount: 0, min: null, max: null },
          { key: "H4-H6", latestCount: 0, min: null, max: null },
          { key: "Bold/B", latestCount: 0, min: null, max: null }
        ];
        this.exactKeyword = [
          { key: "Number of exact keywords in Title", yourCount: 0, min: 0, max: 1 },
          { key: "Number of exact keywords in H1", yourCount: 0, min: 0, max: 1 },
          { key: "Number of exact keywords in Body", yourCount: 0, min: 0, max: 1 },
          { key: "Number of exact keywords in Paragraph", yourCount: 0, min: 0, max: 0 },
          { key: "Number of exact keywords in H2", yourCount: 0, min: 0, max: 0 },
          { key: "Number of exact keywords in H3", yourCount: 0, min: 0, max: 0 },
          { key: "Number of exact keywords in H4-H6", yourCount: 0, min: 0, max: 1 },
          { key: "Number of exact keywords in Strong,B", yourCount: 0, min: 0, max: 0 }
        ];
        this.noOfElements = [
          { key: "No. of H1 elements", yourCount: 0, min: 0, max: 1 },
          { key: "No. of Paragraph elements", yourCount: 0, min: 0, max: 0 },
          { key: "No. of H2 elements", yourCount: 0, min: 0, max: 0 },
          { key: "No. of H3 elements", yourCount: 0, min: 0, max: 0 },
          { key: "No. of H4-H6 elements", yourCount: 0, min: 0, max: 1 },
          { key: "No. of Strong,B elements", yourCount: 0, min: 0, max: 0 },
          { key: "No. of Image elements", yourCount: 0, min: 0, max: 0 }
        ];
        this.quickFix = [
          { key: "Main keyword in Title", yourCount: 0 },
          { key: "Main keyword in H1", yourCount: 0 },
          { key: "H1 tag used", yourCount: 0 },
          { key: "Title tag used", yourCount: 0 },
        ]
        this.auditReportData = res;
        this.auditReportData['structure'] = this.structureObj;
        this.paaData = res?.audit?.paa;
        this.titleData = res?.audit?.keywords_title?.map((e: any) => {
          let mx = res.editor?.audit?.base?.title?.kw[e.keyword] ? res.editor?.audit?.base?.title?.kw[e.keyword]?.length : 0;
          e['suggestedCount'] = { min: Math.floor(e.min * mx), max: Math.floor(e.max * mx) }
          e.isTitle = true; e.yourCount = 0; return e
        });
        res.audit.keywords = res.audit.keywords.map((e: any) => {
          return { ...e, nlp: e.occurance > this.nlp_score ? true : false }
        });
        this.metaDesc.yourCount = res.audit.base?.meta_description[0] ? res.audit.base?.meta_description[0]?.replace(/\s/g, "").length : 0;
        for (let keyy in res?.audit?.data) {
          let elementLength = {
            title: 0,
            h1: 0,
            body: 0,
            p: 0,
            h2: 0,
            h3: 0,
            h46: 0,
            b: 0,
          }
          elementLength.body = res?.audit?.data[keyy]?.body[this.auditReportData.audit.keyword];
          for (let key in res?.audit?.data[keyy]?.p?.text) {
            res?.audit?.data[keyy].p?.text[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.p += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.title?.kw) {
            res?.audit?.data[keyy]?.title?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.title += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.h1?.kw) {
            res?.audit?.data[keyy]?.h1?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h1 += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.h2?.kw) {
            res?.audit?.data[keyy]?.h2?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h1 += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.h3?.kw) {
            res?.audit?.data[keyy]?.h3?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h3 += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.h46?.kw) {
            res?.audit?.data[keyy]?.h46?.kw[key].forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.h46 += 1;
              }
            })
          }
          for (let key in res?.audit?.data[keyy]?.b?.text) {
            res?.audit?.data[keyy]?.b.text[key]?.forEach((el: any) => {
              if (el.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
                elementLength.b += 1;
              }
            })
          }
          res.audit.data[keyy]['eleLength'] = elementLength;
        }
        this.titleData.forEach(e => {
          if (!!res.audit.base?.title.kw[e.keyword]) {
            e['yourCount'] = res.audit.base?.title.kw[e.keyword]?.length;
          }
          // let count = 0;
          // for (let key in res?.audit?.base?.title?.kw) {
          //   res?.audit?.base?.title?.kw[key].forEach((el: any) => {
          //     if (el.includes(this.auditReportData.audit.keyword)) {
          //       count = count + 1
          //       e['yourCount'] = count;
          //     }
          //   })
          // }
        })


        this.h1Data = res?.audit?.keywords_h1?.map((e: any) => { e.isH1 = true; e.yourCount = 0; e.isH = true; return e });
        this.h1Data.forEach(e => {
          if (!!res.audit.base?.h1.kw[e.keyword]) {
            e['yourCount'] = res.audit.base?.h1.kw[e.keyword]?.length;
          }
          // let count = 0;
          // for (let key in res?.audit?.base?.h1?.kw) {
          //   res?.audit?.base?.h1?.kw[key].forEach((el: any) => {
          //     if (el.toLowerCase().includes(e?.keyword.toLowerCase())) {
          //       count = count + 1
          //       e['yourCount'] = count;
          //     }
          //   })
          // }

        })

        this.h2Data = res?.audit?.keywords_h2?.map((e: any) => { e.isH1 = true; e.yourCount = 0; e.isH = true; return e });
        this.h2Data.forEach(e => {
          if (!!res.audit.base?.h2.kw[e.keyword]) {
            e['yourCount'] = res.audit.base?.h2.kw[e.keyword]?.length;
          }
          // let count = 0;
          // for (let key in res.audit.base?.h2.kw) {
          //   res.audit.base?.h2.kw[key].forEach((el: any) => {
          //     if (el.toLowerCase().includes(e.keyword.toLowerCase())) {
          //       count = count + 1
          //       e['yourCount'] = count;
          //     }
          //   })
          // }

        })
        let bodyx: any = [];
        let multix = 1;
        Object.values(this.auditReportData.audit.data).forEach((d: any) => { bodyx.push(parseInt(d.word_len.body)) });
        let bodyAvg = Math.floor(bodyx.reduce((a: any, b: any) => a + b, 0) / bodyx.length);
        multix = this.auditReportData.audit.base?.word_len.body / bodyAvg;
        this.mainContentData = res?.audit?.keywords;
        this.mainContentData.forEach(el => {
          el['yourCount'] = 0;
          el['isH'] = (res.audit.keywords_h1.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase()) || res.audit.keywords_h2.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase())) ? true : false,
            el['isTitle'] = res.audit.keywords_title.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase());
          el['suggestedCount'] = { min: Math.floor(el.min * multix), max: Math.floor(el.max * multix) }
        });
        this.titleContentData = this.mainContentData.filter(el => {
          return el.isTitle === true;
        });
        this.mainContentData.forEach(e => {
          // if(!!res.editor.audit.base?.p.text[e.keyword]){
          //   e['yourCount'] = res.editor.audit.base?.p.text[e.keyword]?.length;
          // }
          let count = 0;
          for (let key in res?.audit?.base?.p?.text) {
            if (key === e.keyword.toLowerCase()) {
              e['yourCount'] = res?.audit?.base?.p?.text[key]?.length;
            }
            // res?.audit.base?.p?.text[key]?.forEach((el: any) => {
            //   if (el.toLowerCase().includes(e.keyword.toLowerCase())) {
            //     count = count + 1
            //     e['yourCount'] = count;
            //   }
            // })
          }

        });

        this.nlpData = this.mainContentData.filter(el => {
          return el.nlp === true;
        });
        this.headingData = this.mainContentData.filter(e => {
          return e.isH === true;
        });
        this.top3Data = this.mainContentData.filter(e => { return e.top3 == true }).map(el => { el.isTop3 = true; return el });
        // this.mainContentData = [...this.mainContentData, ...this.top3Data];
        this.score = res.audit.content_score;
        let checkKeyinH1 = res?.audit?.base?.h1?.text?.some((e: any) => { e.includes(res?.audit?.keyword) });
        let checkKeyinTitle = res?.audit?.base?.title?.text?.some((e: any) => { e.includes(res?.audit?.keyword) });
        if (!!checkKeyinH1 || !!checkKeyinTitle) {
          this.isAvailable = true;
        }
        if (!!checkKeyinH1) {
          this.isH1Available = true;
        }
        if (!!checkKeyinTitle) {
          this.isTitleAvailable = true;
        }
        this.quickFix[2].yourCount = this.auditReportData.audit.base?.h1.count;
        this.quickFix[3].yourCount = this.auditReportData.audit.base?.title.count;
        this.noOfElements[0].yourCount = this.auditReportData?.audit?.base?.h1?.count;
        this.noOfElements[1].yourCount = this.auditReportData?.audit?.base?.p?.count;
        this.noOfElements[2].yourCount = this.auditReportData?.audit?.base?.h2?.count;
        this.noOfElements[3].yourCount = this.auditReportData?.audit?.base?.h3?.count;
        this.noOfElements[4].yourCount = this.auditReportData?.audit?.base?.h4?.count + this.auditReportData?.audit?.base?.h5?.count + this.auditReportData?.audit?.base?.h6?.count;
        this.noOfElements[5].yourCount = this.auditReportData?.audit?.base?.b?.count;
        this.noOfElements[6].yourCount = this.auditReportData?.audit?.base?.img?.count;

        if (this.auditReportData.audit.base?.h1?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.quickFix[1].yourCount += 1;
        }
        // this.auditReportData.audit.base?.title?.text?.forEach((e: any) => {
        if (this.auditReportData.audit.base?.title?.text[0]?.toLowerCase().includes(this.auditReportData.audit.keyword.toLowerCase())) {
          this.quickFix[0].yourCount += 1;
        }
        // })
        this.topCompetitorTitle = [];
        this.getMinmax();
        this.getDensity();
        this.initGraphs();
      }
      this.loading = false;
    })
  }
  softRefresh() {
    let x: any = [];
    this.mainContentData?.forEach((v: any) => {
      x.push(v.keyword)
    })

    this.editorService.completeAudit({ req_type: "soft_refresh", uid: this.uid, _keywords: x }, this.aid).subscribe(res => {
      if (!!res && res.message && res.message === "Refresh has been started.") {
        this.refreshFlag = true
        this.socket.emit("updater", this.aid);
        this.toster.success("Refresh has been started.")
      }
    })
  }
  onValChange(value: any) {
    this.mainContentSwitch = value;
    setTimeout(() => {
      this.getFilteredKeyword();
    }, 500);
  }
  saveAuditScore() {
    this.editorService.saveAuditScore({ aid: this.aid, score: Math.round(this.score) }).subscribe(res => {
    })
  }
  getFilteredKeyword() {
    let backupMainContentData: any;
    let backupTitleData: any;
    let backupTop3Data: any;
    let backupNlpData: any;
    let backupHeadingData: any;

    let bodyx: any = [];
    let multix = 1;
    Object.values(this.auditReportData.audit.data).forEach((d: any) => { bodyx.push(parseInt(d.word_len.body)) });
    let bodyAvg = Math.floor(bodyx.reduce((a: any, b: any) => a + b, 0) / bodyx.length);
    multix = this.auditReportData.audit.base?.word_len.body / bodyAvg;
    backupMainContentData = this.auditReportData.audit?.keywords;
    backupMainContentData.forEach((el: any) => {
      el['isH'] = (this.auditReportData.audit?.keywords_h1.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase()) || this.auditReportData.audit?.keywords_h2.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase())) ? true : false,
        el['isTitle'] = this.auditReportData.audit?.keywords_title.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase());
      el['suggestedCount'] = { min: Math.floor(el.min * multix), max: Math.floor(el.max * multix) }

    });
    backupTitleData = backupMainContentData.filter((el: any) => {
      return el.isTitle === true;
    });
    backupHeadingData = backupMainContentData.filter((el: any) => {
      return el.isH === true;
    });
    backupTop3Data = backupMainContentData.filter((e: any) => { return e.top3 == true }).map((el: any) => { el.isTop3 = true; return el });
    backupNlpData = backupMainContentData.filter((el: any) => {
      return el.nlp === true;
    });
    if (!this.isoptimised && !this.isPartial && !this.isNotUsed) {
      this.mainContentData = this.auditReportData.audit?.keywords;
      this.mainContentData.forEach(el => {
        el['isH'] = (this.auditReportData?.audit?.keywords_h1?.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase()) || this.auditReportData?.audit?.keywords_h2.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase())) ? true : false,
          el['isTitle'] = this.auditReportData?.audit?.keywords_title?.some((ele: any) => ele.keyword.toLowerCase() === el.keyword.toLowerCase());
        el['suggestedCount'] = { min: Math.floor(el.min * multix), max: Math.floor(el.max * multix) }
      });
      this.titleContentData = this.mainContentData.filter(el => {
        return el.isTitle === true;
      });
      this.nlpData = this.mainContentData.filter(el => {
        return el.nlp === true;
      });
      this.headingData = this.mainContentData.filter(e => {
        return e.isH === true;
      });
      this.top3Data = this.mainContentData.filter(e => { return e.top3 == true }).map(el => { el.isTop3 = true; return el });
    } else {
      this.mainContentData = backupMainContentData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.top3Data = backupTop3Data.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.nlpData = backupNlpData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.titleContentData = backupTitleData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
      this.headingData = backupHeadingData.filter((e: any) => {
        if (this.filterOptimised(e) || this.filterNonUsed(e) || this.filterPartial(e)) {
          return true;
        }
        else {
          return false;
        }
      })
    }
  }
  filterOptimised(element: any) {
    // let backupAllData: any;
    // backupAllData = [...this.mainContentData, ...this.h1Data, ...this.h2Data, ...this.titleData, ...this.top3Data];
    if (this.mainContentSwitch === 'idle') {
      if (this.isoptimised) {
        if (element.yourCount !== 0 && element.min <= element.yourCount && element.yourCount <= element.max) {
          return true;
        } else {
          return false
        }
      } else {
        return false;
      }
    } else {
      if (this.isoptimised) {
        if (element.yourCount !== 0 && element.suggestedCount.min <= element.yourCount && element.yourCount <= element.suggestedCount.max) {
          return true;
        } else {
          return false
        }
      } else {
        return false;
      }
    }

  }
  filterPartial(element: any) {
    if (this.mainContentSwitch === 'idle') {
      if (this.isPartial) {
        if (0 < element.yourCount && element.yourCount < element.min) {
          return true;
        } else {
          return false
        }
      } else {
        return false;
      }
    } else {
      if (this.isPartial) {
        if (0 < element.yourCount && element.yourCount < element.suggestedCount.min) {
          return true;
        } else {
          return false
        }
      } else {
        return false;
      }
    }

  }
  filterNonUsed(element: any) {
    if (this.isNotUsed) {
      if (element.yourCount == 0) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }
}
